// keys for local storage table settings
import { DeviceCommissioningOverview } from "../pages/elion_site/tabs/commissioning_tab/components/phase_detail_components/device_overview/device_commissioning_overview";

export const REACT_TABLE_NAMES = Object.freeze({
  CRM_OVERVIEW: "elion_crm_overview",
  SITE_OVERVIEW: "overview_site", // renamed to reset default columns in v2.6.0
  USER_MANAGEMENT: "user_overview",
  DEVICE_COMMISSIONING_OVERVIEW: "device_commissioning_overview",
});
